<template>
  <svg fill="none" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
    <path
      xmlns="http://www.w3.org/2000/svg"
      d="M6 5.11649V12.8842C6 13.476 6.65325 13.8345 7.15275 13.5172L13.2555 9.63374C13.719 9.33899 13.719 8.66324 13.2555 8.36849L7.15275 4.48349C6.65325 4.16549 6 4.52474 6 5.11649Z"
      fill="currentColor"></path>
  </svg>
</template>
